'use strict';exports.__esModule = true;exports.sendVRPaymentNotification = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var sendVRPaymentNotification = (0, _reduxAct.createAction)('/SEND_VR_PAYMENT_NOTIFICATION');
var sendVRPaymentNotificationSuccess = (0, _reduxAct.createAction)('/SEND_VR_PAYMENT_NOTIFICATION_SUCCESS');
var sendVRPaymentNotificationFail = (0, _reduxAct.createAction)('/SEND_VR_PAYMENT_NOTIFICATION_FAIL');

var initialState = {
  sending: false,
  sent: false };


var sendHandlerSuccess = function sendHandlerSuccess(state) {return Object.assign({},
  state, {
    sending: false,
    sent: true });};


var sendHandlerFail = function sendHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while sending notification');
  return Object.assign({},
  state, {
    sending: false,
    sent: false,
    error: error });

};

var sendRequest = function sendRequest(data) {return _axios2.default.post('messaging/contact-all-vr-photo-companies', data).
  then(sendVRPaymentNotificationSuccess, sendVRPaymentNotificationFail);};

var sendHandler = function sendHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { sending: true }), promise(sendRequest, data));};

var notifications = (0, _reduxAct.createReducer)(function (on) {
  on(sendVRPaymentNotification, sendHandler);
  on(sendVRPaymentNotificationSuccess, sendHandlerSuccess);
  on(sendVRPaymentNotificationFail, sendHandlerFail);
}, initialState);exports.


sendVRPaymentNotification = sendVRPaymentNotification;exports.default =


notifications;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/notifications.js
// module id = 1263
// module chunks = 0